import { doc, runTransaction } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Zwalnia miejsce ("od-rejestruje") danego kandydata z warsztatów dla konkretnego eventu.
 */
export const deleteRegistration = async (formId, registrationId, selectedOptionIds) => {
    try {
        await runTransaction(db, async (transaction) => {
            const regRef = doc(db, "forms", formId, "registrations", registrationId);
            
            // Check if reg exists
            const regDoc = await transaction.get(regRef);
            if (!regDoc.exists()) {
                throw new Error("Tego zgłoszenia już nie ma w bazie.");
            }

            // Restore the spots for the options
            const optionsToUpdate = [];
            for (const optionId of selectedOptionIds) {
                const optionRef = doc(db, "forms", formId, "options", optionId);
                const optionDoc = await transaction.get(optionRef);
                if (optionDoc.exists()) {
                    optionsToUpdate.push({
                        ref: optionRef,
                        currentSpotsLeft: optionDoc.data().spotsLeft || 0
                    });
                }
            }

            // Perform writes
            for (const opt of optionsToUpdate) {
                transaction.update(opt.ref, {
                    spotsLeft: opt.currentSpotsLeft + 1
                });
            }

            // Delete the registration document
            transaction.delete(regRef);
        });
    } catch (error) {
        throw new Error(error.message || "Błąd podczas usuwania zgłoszenia.");
    }
};
